<script>
  import { format } from 'svelte-i18n';
  import { Alert, Badge, Button, Column, Progress, Spinner, Table } from '@sveltestrap/sveltestrap';

  import { SearchFilter } from '@client/components/filters/search';
  import { Icon } from '@client/components/icon';

  import { exportDataToCSV } from '@client/utils/csv';

  export let current = 0;
  export let failures = 0;
  export let sending = false;
  export let results = [];
  export let successes = 0;
  export let total = 1;

  let search;

  const onExport = async () => {
    const data = results.map((result) => ({
      username: result.username,
      status: result.status,
      message: result.message
    }));

    exportDataToCSV(data, 'welcome-email-results');
  };

  $: filteredResults =
    search?.length > 1
      ? results.filter((row) =>
          Object.values(row).some(
            (value) => typeof value === 'string' && value.toLowerCase().includes(search.toLowerCase())
          )
        )
      : results;
</script>

<div>
  {#if sending}
    <Progress value={Math.ceil((current / total) * 100)}>
      {Math.ceil((current / total) * 100)}%
    </Progress>

    <p class="p-3 text-center">
      {$format('label.PUSHER_PROGRESS', {
        values: { n: current, total }
      })}
    </p>
  {:else}
    {#if !total}
      <Alert color="warning" class="d-flex align-items-center mb-3">
        <h5 class="mb-0">
          <Icon name="alert-triangle" />
          {$format('label.BIZCARD_PUSHER_NO_USERS')}
        </h5>
      </Alert>
    {:else if successes}
      <Alert color="success" class="d-flex align-items-center mb-3">
        <h5 class="mb-0">
          <Icon name="check-circle" />
          {$format('label.PUSHER_SUCCESSES', {
            values: { n: successes }
          })}
        </h5>
        <Button class="ms-auto" color="success" on:click={onExport} outline size="sm">
          {$format('label.EXPORT_RESULTS')}
        </Button>
      </Alert>
    {/if}
    {#if failures}
      <Alert color="danger" class="d-flex align-items-center mb-3">
        <h5 class="mb-0">
          <Icon name="alert-triangle" />
          {$format('label.PUSHER_FAILURES', {
            values: { n: failures }
          })}
        </h5>
        {#if !successes}
          <Button class="ms-auto" color="danger" on:click={onExport} outline size="sm">
            {$format('label.EXPORT_RESULTS')}
          </Button>
        {/if}
      </Alert>
    {/if}
  {/if}

  {#if results.length}
    <div class="mb-3">
      <SearchFilter bind:search />
    </div>

    <div class="scrollable">
      <Table rows={filteredResults} size="sm" let:row>
        <Column header={$format('label.STATUS')} width="33%">
          {#if row.status === 'error'}
            <span id={row.username}>
              <Badge color="danger">
                {$format('label.FAILURE.PUSH_STATUS')}
              </Badge>
            </span>
          {:else if row.status === 'sent'}
            <Badge color="success">
              {$format('label.SUCCESS.PUSH_STATUS')}
            </Badge>
          {:else}
            <Spinner color="primary" size="sm" />
          {/if}
        </Column>
        <Column header={$format('label.USERNAME')}>
          {row.username}
        </Column>
      </Table>
    </div>
  {/if}
</div>

<style>
  .scrollable {
    max-height: 40vh;
    overflow-y: auto;
  }
</style>
